














































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { Urls } from "@/Urls";

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    name: 'LinkShareDialog',
    components: {
        CardTitle,
    },
    directives: {},
})
export default class LinkShareDialog extends Vue {
    private show = false;
    private copiedTooltip = false;
    private authFlow = true;
    private pinned = false;
    private promote = false;
    private chart = false;
    private template = '';
    private newChoiceDialog = false;

    @Prop()
    shareForm: string

    get currentUrl() {
        return workspaceOptionsModule.currentUrl;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpoints
    }

    get choiceList() {
        return choicesModule.choicesList;
    }

    get generatedLink() {
        let link = '';
        link = Urls.DOMAIN + '/app/share';
        if (this.currentUrl) {
            link = `${link}${this.currentUrl.params}`;
        }
        link = `${link}&autocomplete=${this.shareForm}`;
        link = `${link}&authFlow=${this.authFlow}&pinnedRight=${this.pinned}&chartTop=${this.chart}&promote=${this.promote}${this.template === undefined || this.template === '' ? '' : `&template=${this.template}`}`;
        if(this.shareForm === 'choice') {
            link = `${link}&createChoice=${this.newChoiceDialog}`
        }
        return link;
    }

    // new viewpoint = true, make a new one

    private copy() {
        this.copiedTooltip = true;
        setTimeout(() => (this.copiedTooltip = false), 3000);
    }

}
